// Import Config.
import { CONFIG_ENVIRONMENT } from '../../config';

export enum LogLevels {
  verbose,
  info,
  warnings,
  errors
}

let logLevel: LogLevels;

// The value of CONFIG_ENVIRONMENT is replaced at build time which confuses tsc so we have to ts-ignore it
switch(CONFIG_ENVIRONMENT) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  case 'PRODUCTION':
    logLevel = LogLevels.errors;
    break;
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  case 'QA':
    logLevel = LogLevels.info;
    break;
  default:
    logLevel = LogLevels.verbose;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debug(...args: any[]): void {
  if (logLevel <= LogLevels.verbose) {
    window.console.debug.apply(window, args);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function info(...args: any[]): void {
  if (logLevel <= LogLevels.info) {
    window.console.info.apply(window, args);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function warn(...args: any[]): void {
  if (logLevel <= LogLevels.warnings) {
    window.console.warn.apply(window, args);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function error(...args: any[]): void {
  if (logLevel <= LogLevels.errors) {
    window.console.error.apply(window, args);
  }
}
